export const validateUsername = (username: string = ''): string | null =>
  username.match(/^[\w]{3,64}$/) ? null : 'Username is invalid';
